export default __webpack_public_path__ + "static/media/diskIcon.d82da185.svg";